import React from 'react';
import { Box, Popover } from '@mui/material';
import { ServerNotification } from '../../../types/serverNotifications/serverNotificationTypes';
import Notifications from './notifications/Notifications';
import Processes from './processes/Processes';

interface ActivityPopoverProps {
    anchorEl: HTMLButtonElement | null;
    onClose: () => void;
    notifications: ServerNotification[];
}

/**
 * Displays activity without changing page scrolling or header width.
 * @param props The button anchor, close handler and notifications.
 * @returns A popover containing notifications and processes.
 */
const ActivityPopover = ({
    anchorEl,
    onClose,
    notifications,
}: ActivityPopoverProps) => {
    return (
        <Popover
            id='activity-popover'
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            disableScrollLock
            sx={{
                // The landing header uses z-index 2000.
                zIndex: theme => Math.max(2000, theme.zIndex.tooltip) + 1,
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            slotProps={{
                paper: {
                    role: 'dialog',
                    'aria-labelledby': 'activity-button',
                },
            }}
        >
            <Box className='activity__content'>
                <Processes />
                <Notifications
                    notifications={notifications}
                    onNavigate={onClose}
                />
            </Box>
        </Popover>
    );
};

export default ActivityPopover;
